import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Guid from "common/values/guid/guid";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

const NameLink = styled(Link)(({ theme }) => ({
  alignItems: "center",
  color: theme.palette.text.primary,
  cursor: "pointer",
  display: "flex",
  fontWeight: 500,
  marginRight: "auto",
  textAlign: "left",
  textDecorationColor: theme.palette.text.primary,
})) as typeof Link;

export type GranteeCellProps = Readonly<{
  userId: Guid;
  name?: string;
  isLoading?: boolean;
  error?: string | null;
}>;

/**
 * GranteeNameCell: renders the grantee/grantor name cell with loading & error states
 */
export default function GranteeNameCell({ userId, name, isLoading, error }: GranteeCellProps): ReactNode {
  if (isLoading) return "Loading...";
  if (error) return `(Error: ${error})`;
  if (name)
    return (
      <NameLink to={{ search: `?granteeUserId=${userId}` }} component={RouterLink}>
        {name}
      </NameLink>
    );
  return <Icon>remove</Icon>;
}
